import { render, staticRenderFns } from "./OffersSection.vue?vue&type=template&id=7bd2cca4&scoped=true"
import script from "./OffersSection.vue?vue&type=script&lang=js"
export * from "./OffersSection.vue?vue&type=script&lang=js"
import style0 from "./OffersSection.vue?vue&type=style&index=0&id=7bd2cca4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd2cca4",
  null
  
)

export default component.exports